import(/* webpackMode: "eager" */ "/vercel/path0/src/app/auth/page.tsx");
